/** PassADC brand mark - the tooth icon. Use everywhere the logo appears. */
export const BrandLogo = ({ size = 24, className = "" }) => (
  <img
    src="/icon-192.png"
    alt="PassADC"
    width={size}
    height={size}
    className={`rounded-md ${className}`}
    data-testid="brand-logo"
  />
);

export default BrandLogo;
